import React from 'react';
import { Pane, Flex, Label, NumericInput, Button, Selector } from '@leverege/ui-elements';
import classnames from 'classnames';
import I18N from '@leverege/i18n';
import S from './TablePagination.css';
const {
  t
} = I18N.ns('pairing.bulkPairing.views.TablePagination');
export default class TablePagination extends React.Component {
  render() {
    const {
      footerClassName,
      setPageSize,
      pageSize,
      rangeMin,
      rangeMax,
      totalSize,
      canPreviousPage,
      previousPage,
      canNextPage,
      pageIndex,
      pages,
      gotoPage,
      nextPage
    } = this.props;
    return /*#__PURE__*/React.createElement(Pane, {
      className: classnames(S.content, footerClassName),
      variant: "tablePagination"
    }, /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      justify: "space-between",
      className: S.flex
    }, /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      variant: "rowM"
    }, /*#__PURE__*/React.createElement(Label, {
      htmlFor: "perPage"
    }, t('rowsPerPage')), /*#__PURE__*/React.createElement(NumericInput, {
      id: "perPage",
      variant: "perPage",
      onChange: evt => {
        setPageSize(evt.value);
      },
      value: pageSize
    })), /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      variant: "rowM"
    }, /*#__PURE__*/React.createElement(Label, {
      variant: "inputCaption|caption"
    }, t('size', {
      rangeMin,
      rangeMax,
      totalSize
    })), /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      justify: "center"
    }, canPreviousPage && /*#__PURE__*/React.createElement(Button, {
      variant: "paginationPrev",
      onClick: previousPage,
      className: S.leftArrow
    }), (canPreviousPage || canNextPage) && /*#__PURE__*/React.createElement(Selector, {
      variant: "pagination",
      value: pageIndex,
      values: pages,
      onChange: gotoPage
    }), canNextPage && /*#__PURE__*/React.createElement(Button, {
      variant: "paginationNext",
      onClick: nextPage,
      className: S.rightArrow
    })))));
  }
}